export class ApiError extends Error {
    constructor(public status: number, message: string) {
        super(message);
        this.name = 'ApiError';
    }
}

export const authenticatedFetch = async (url: string, options: RequestInit = {}) => {
    const token = localStorage.getItem('token');

    const headers = new Headers(options.headers);
    if (token) {
        headers.set('Authorization', `Bearer ${token}`);
    }

    // Ensure Content-Type is set for POST/PUT if not already present and not FormData
    if (!headers.has('Content-Type') &&
        !((options.body instanceof FormData)) &&
        (options.method === 'POST' || options.method === 'PUT' || options.method === 'PATCH')) {
        headers.set('Content-Type', 'application/json');
    }

    const config: RequestInit = {
        ...options,
        headers,
    };

    try {
        const response = await fetch(url, config);

        // Automatic Token Refresh
        const refreshToken = response.headers.get('X-Refresh-Token');
        if (refreshToken) {
            localStorage.setItem('token', refreshToken);
        }

        if (response.status === 401) {
            // Dispatch logout event
            window.dispatchEvent(new CustomEvent('auth:logout'));
            throw new ApiError(401, 'Session expired');
        }

        return response;
    } catch (error) {
        throw error;
    }
};
